<template>
  <div  >
    <div v-show="loading"  v-loading="loading" style="height:100vh">

    </div>
    <div id="particles" v-show="!loading" class=" animated fadeInUp" >
      <div class="container animated zoomIn" >
        <img src="../assets/img/logo1.png" alt >
        <br>
        <br>
        <br>
        <br>
        <br>
        <div>
          <el-button type="success">确认</el-button>
        </div>
        <br>
        <div>
          <el-button type="warning">取消</el-button>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "scanin",
  data(){
    return{
      loading:true
    } //#endregion
  },
 
 mounted(){     
    // https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc30e3d953791af1b&redirect_uri=http%3a%2f%2fwww.yzparking.cn&response_type=code&scope=snsapi_base&state=123#wechat_redirect

//   this.axios.get('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7247994487b2617a&redirect_uri=http%3a%2f%2fwww.kcsmkj.cn%2fwechat&response_type=code&scope=snsapi_base&state=STATE&#wechat_redirect').then(res=>{
//  alert(res)
//   })
   window.open('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7247994487b2617a&redirect_uri=http%3a%2f%2fwww.kcsmkj.cn%2fwechat%2fscanin&response_type=code&scope=snsapi_base&state=STATE&#wechat_redirect')
   setTimeout(()=>{
     this.loading=false
   },1000)
 
 }


};
</script>

<style scoped>
#particles {
  text-align: center;
  background-image: linear-gradient(
    to top,
    rgb(136, 211, 206) 0%,
    rgb(47, 44, 150) 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 100% 100%;
  height: 100vh;
}

.container {
  padding-top: 13vh;
}   
img {
  height: 150px;
  width: 150px;
}
button {
  width: 50%;
  padding: 18px 25px;
  font-size: 17px;
}
</style>


// WEBPACK FOOTER //
// src/components/scanin.vue